import { cn } from "./cn";

export const SPINNER_SIZE_CLASSES = {
  xs: "h-2.5 w-2.5 border",
  sm: "h-3.5 w-3.5 border-[1.5px]",
  md: "h-5 w-5 border-2",
  lg: "h-8 w-8 border-2",
} as const satisfies Record<string, string>;

export type SpinnerSize = keyof typeof SPINNER_SIZE_CLASSES;

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

export function Spinner({ size = "md", className, label = "Cargando" }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        "inline-block animate-spin rounded-full border-current border-r-transparent align-[-0.125em]",
        SPINNER_SIZE_CLASSES[size],
        className,
      )}
    />
  );
}
